import React from 'react'

import {
    TemplateService,
    ezScheduleDetails,
    TemplateWorkorder,
} from '../../../../models'

import { Theme } from '@material-ui/core'

import { Container } from '../../../Container'
import { VENDOR_BAR_H, MARGIN, HEADER_H } from '../../constants'
import { TemplateVendorChartBar } from './TemplateVendorChartBar'
import { CalendarGridController } from '../../hooks'
import { DateTime } from 'luxon'
import { TimezoneState } from '../../../../contexts/timezone/timezone'
import { UpdateTemplateServiceVendorParams } from '../../../../hooks/useEzSchedule/types'

interface Props {
    templateService: TemplateService
    gridState: CalendarGridController
    projectStartDate: DateTime
    projectEndDate: DateTime
    prevRowCount: number
    timezoneState: TimezoneState
    theme: Theme
    ezSchedule: ezScheduleDetails
    templateWorkorders?: TemplateWorkorder[]
    workordersByVendorDate: Map<string, TemplateWorkorder[]>
    updateTemplateServiceVendor: (
        params: UpdateTemplateServiceVendorParams,
    ) => void
    selectedPhaseId: number
}

export const TemplateServiceChartRow = (props: Props) => {
    const {
        templateService,
        prevRowCount,
        timezoneState,
        theme,
        ezSchedule,
        templateWorkorders,
        workordersByVendorDate,
        updateTemplateServiceVendor,
        selectedPhaseId,
    } = props

    const vendorCount = templateService.template_service_vendors.length

    // Skip past calendar header + all previous rows + 1 for this service's header row
    const topOffset = HEADER_H + (prevRowCount + 1) * VENDOR_BAR_H

    const containerHeight = vendorCount * VENDOR_BAR_H

    let minStartDate: DateTime | null = null
    if (
        templateService.min_start_date &&
        templateService.min_start_date !== ''
    ) {
        minStartDate = DateTime.fromISO(templateService.min_start_date).setZone(
            timezoneState.currentTimezone,
        )
    }

    return (
        <Container
            style={{
                top: topOffset,
                height: containerHeight,
                flexDirection: 'column',
                boxSizing: 'border-box',
                minHeight: VENDOR_BAR_H,
                position: 'absolute',
                left: 0,
                right: 0,
            }}
            onClick={(e) => e.stopPropagation()}
        >
            {templateService.template_service_vendors.map(
                (templateServiceVendor) => {
                    return (
                        <TemplateVendorChartBar
                            key={`VND-BAR-${templateServiceVendor.id}`}
                            {...props}
                            templateServiceVendor={templateServiceVendor}
                            templateService={templateService}
                            color={templateService.service.color}
                            margin={MARGIN}
                            minStartDate={minStartDate}
                            theme={theme}
                            ezSchedule={ezSchedule}
                            templateWorkorders={templateWorkorders}
                            workordersByVendorDate={workordersByVendorDate}
                            updateTemplateServiceVendor={
                                updateTemplateServiceVendor
                            }
                            selectedPhaseId={selectedPhaseId}
                        />
                    )
                },
            )}
        </Container>
    )
}
